import fetch from 'utils/fetch';

export function purchaseEsim(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/purchaseEsim',
        method: 'post',
        data
    });
}

export function purchaseEsimList(requestData) {
    return fetch({
        url: '/purchaseEsimList',
        method: 'get',
        params: requestData
    });
}

export function purchaseEsimDownload(requestData) {
    return fetch({
        url: '/purchaseEsimDownload',
        method: 'get',
        params: requestData
    });
}

export function purchaseEsimPreview(requestData) {
    return fetch({
        url: '/purchaseEsimPreview',
        method: 'get',
        params: requestData
    });
}

export function sendToEmail(requestData) {
    return fetch({
        url: '/sendToEmail',
        method: 'get',
        params: requestData
    });
}



// WEBPACK FOOTER //
// ./src/api/esimPurchase.js